export function InfoSolidNavyIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <g clipPath="url(#clip0_933_17283)">
        <path
          d="M6.6 9.49997H7.1V8.99997V5.39997V4.89997H6.6H5.4H4.9V5.39997V8.99997V9.49997H5.4H6.6ZM6.6 4.69997H7.1V4.19997V2.99997V2.49997H6.6H5.4H4.9V2.99997V4.19997V4.69997H5.4H6.6ZM0.5 5.99997C0.5 2.96411 2.96414 0.499969 6 0.499969C9.03586 0.499969 11.5 2.96411 11.5 5.99997C11.5 9.03583 9.03586 11.5 6 11.5C2.96414 11.5 0.5 9.03583 0.5 5.99997Z"
          fill="#002035"
          stroke="#002035"
        />
      </g>
      <defs>
        <clipPath id="clip0_933_17283">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
